{
    "Para1ChartingEnabled": "You can choose whether printable output for reports includes a summary header showing information for the corresponding report, as well as whether both the tabulated report row content and/or a chart representation is displayed.",
    "Para1ChartingDisabled": "You can choose whether printable output for reports includes a summary header showing information for the corresponding report.",
    "PrintableOutputIncludesLabel": "Printable Output Includes:",
    "ShowSummaryHeaderLabel": "Show Summary Header:",
    "Para2": "You can select if a header and/or footer row is shown for the tabulated data of printable and/or exported report output, in addition to choosing whether report content data rows are actually included.",
    "TableAndChartIfAvailable": "Tabulated Data + Chart (If Available)",
    "TableAndChart": "Tabulated Data + Chart (Always)",
    "TableOnly": "Tabulated Data Only",
    "ChartOnly": "Chart Only",
    "NAME": "PrintOutput",
    "PrintOutput_SectionHeader": "Print Output Options"
}